import {
  withVersion
} from "./chunk-UEDPR2CR.js";

// lib/api/logout.ts
import { logInfo } from "@lune/common/logger";
var logoutHandlerFactory = (version, loginUrl, rootUrl, onBeforeLogout = () => {
}) => () => {
  logInfo("Logoff in progress");
  onBeforeLogout();
  withVersion(version, loginUrl, rootUrl).then(async (auth) => await auth.logout()).then((navigator) => {
    logInfo("Navigating to login", navigator, navigator.navigate);
    navigator.navigate();
  }).catch((err) => {
    console.error("Cannot logout", err);
  });
};

export {
  logoutHandlerFactory
};
